import { useEffect, useMemo, useState } from 'react';
import { getFactor } from '../functions';

// Hook to fetch and cache conversion factors between units
export default function useConversionFactor(fromUnit, toUnit) {
  const [factor, setFactor] = useState(1);
  const [loading, setLoading] = useState(false);
  const cache = useMemo(() => new Map(), []);

    useEffect(() => {
    if (fromUnit == null || toUnit == null) return;

    const key = `${String(fromUnit)}->${String(toUnit)}`;
    if (cache.has(key)) {
      const cached = cache.get(key);
      setFactor(cached);
      return;
    }

    let mounted = true;
    setLoading(true);
    (async () => {
      try {
        const resp = await getFactor(toUnit);
        const data = resp && resp.data ? resp.data : 1;
        const f = data && Number(data.factor) ? Number(data.factor) : 1;
        cache.set(key, f);
        if (mounted) setFactor(f);
      } catch (err) {
        if (mounted) setFactor(1);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => { mounted = false; };
  }, [fromUnit, toUnit, cache]);

  return { factor, loading };
}
